import {getFromHubNew} from './networkActions';

export function recordVisit(path) {
    //remove any leading slashes and default to "home" if no path given
    path = path.replace(/^\/+/g, '') || "home";

    getFromHubNew(`metrics/userhistory/${path}`, () => {});
}